import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import style from "../../css/dashboard/Dashboard.module.css";
import StudyMaterial_data from "../Dashboard/Study_material/Studymaterial_data";

import ProfileEditModal from "./ProfileEditModal";
import NotificationBar from "./NotificationBar";
import notifications from "./NotificationData";
import DashboardLanding from "./landing_dash/DashboardLanding";
import { API_BASE_URL } from "../ApiConfig";
import ThemeToggle from "../Theme_toggle";
import Scaner from "./Scaner/Scaner";
import ViewWorkshops from "./workshop/Workshop_data";
import Community_data from "./Community/Community_data";

import Premium from "../Payment/Premium";
import Fundamentaldash from "./Fundamental/Fundamentaldash";
import News from "./news&events/News";
import AiChatbot from "./Chatbot/AiChatbot.js";
import Sector from "./Sector_rotation/Sector";
import { checkPlanStatus, getSecureToken } from "../ApisService/apiService.js";
import StockAnalysis from "../StockAnalysis.js";
import StockChat from "../StockChat.js";
import AI_bot from "./Chatbot/AI_bot.js";
import SubscriptionPopup from "./SubscriptionPopup.js";
import axios from "axios";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedSection, setSelectedSection] = useState("");
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [isNotificationBarOpen, setNotificationBarOpen] = useState(false);
  const notificationBarRef = useRef(null);

  useEffect(() => {
    const isUserlogin = localStorage.getItem('isuserlogin');
    if (!isUserlogin || isUserlogin !== 'true') {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      const { secrettoken, ts } = await getSecureToken();

      try {
        const res = await axios.get(`${API_BASE_URL}auth/check_user_session.php`, {
          headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts
          },
          withCredentials: true,
        });

        // console.log(res.data);

        if (res.data.status !== "ok") {
          const theme = localStorage.getItem("theme");
          localStorage.clear();
          if (theme) {
            localStorage.setItem("theme", theme);
          }
          navigate('/');

        }

      } catch (error) {
        console.error("Session check failed", error.response?.data || error.message);
        navigate('/');
      }
    };

    checkSession();
  }, []);

  const userEmail = localStorage.getItem("userEmail");

  const [fullName, setFullName] = useState("");
  const [activeTitle, setActiveTitle] = useState("DASHBOARD");
  {
    activeTitle.toUpperCase();
  }

  if (userEmail == "" || userEmail == null) {
    window.location.href = "/";
  }


  const sectionMapping = {
    "/dashboard/ai-chatbot": "AI CHATBOT",
    "/dashboard/news-events": "NEWS & EVENTS",
    "/dashboard/community-group": "COMMUNITY GROUP",
    "/dashboard/sector-rotation": "SECTOR ROTATION",
    "/dashboard/fundamental": "FUNDAMENTAL",
    "/dashboard/study-material": "STUDY MATERIAL",
    "/dashboard/scanners": "SCANNERS",
    "/dashboard/workshop": "WORKSHOP",
    "/dashboard/payment_card": "PREMIUM",
    "/dashboard": "DASHBOARD",
  };

  useEffect(() => {
    const currentPath = location.pathname;

    // Find the best match (longest prefix match)
    const matchedKey = Object.keys(sectionMapping)
      .sort((a, b) => b.length - a.length) // longest match first
      .find((key) => currentPath.startsWith(key));

    setActiveTitle(sectionMapping[matchedKey] || "DASHBOARD");
  }, [location.pathname]);


  const handleSectionChange = (sectionPath) => {
    navigate(sectionPath);

    const sectionMapping = {
      "/dashboard": "DASHBOARD",
      "/dashboard/workshop": "WORKSHOP",
      "/dashboard/scanners": "SCANNERS",
      "/dashboard/study-material": "STUDY MATERIAL",
      "/dashboard/fundamental": "FUNDAMENTAL",
      "/dashboard/sector-rotation": "SECTOR ROTATION",
      "/dashboard/community-group": "COMMUNITY GROUP",
      "/dashboard/news-events": "NEWS & EVENTS",
      "/dashboard/payment_card": "PREMIUM",
    };

    setActiveTitle(sectionMapping[sectionPath] || "DASHBOARD");

  };

  const handleProfileClick = () => {
    setProfileModalOpen(true);
  };

  const closeProfileModal = () => {
    setProfileModalOpen(false);
  };

  const toggleNotificationBar = () => {
    setNotificationBarOpen(!isNotificationBarOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationBarRef.current &&
        !notificationBarRef.current.contains(event.target)
      ) {
        setNotificationBarOpen(false);
      }
    };

    if (isNotificationBarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNotificationBarOpen]);

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: "fa-solid fa-house" },
    {
      name: "Workshop",
      path: "/dashboard/workshop",
      icon: "fa-solid fa-chalkboard",
    },
    {
      name: "Screener",
      path: "/dashboard/scanners",
      icon: "fa-solid fa-magnifying-glass",
    },
    {
      name: "Study Material",
      path: "/dashboard/study-material",
      icon: "fa-solid fa-book",
    },
    {
      name: "Fundamental",
      path: "/dashboard/fundamental",
      icon: "fa-solid fa-chart-line",
    },
    {
      name: "Sector rotation",
      path: "/dashboard/sector-rotation",
      icon: "fa-solid fa-exchange-alt",
    },
    {
      name: "Community group",
      path: "/dashboard/community-group",
      icon: "fa-solid fa-users",
    },
    {
      name: "News & Events",
      path: "/dashboard/news-events",
      icon: "fa-solid fa-newspaper",
    },
    {
      name: "PREMIUM",
      path: "/dashboard/payment_card",
      icon: "fa-solid fa-shield",
    },
    // { name: 'AI Chatbot', path: '/dashboard/ai-chatbot', icon: 'fa-solid fa-robot', disabled: true }, // if you want disabled any list item type = { disabled : true  }
    {
      name: "AI Chatbot",
      path: "/dashboard/ai-chatbot",
      icon: "fa-solid fa-robot",
    },

    // { name: 'Stock Details', path: '/dashboard/stock-details' },
  ];
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const updateView = () => {
      setIsMobileView(window.innerWidth <= 992);
    };

    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);

  useEffect(() => {
    // Retrieve the stored user name from localStorage
    const storedFullName = localStorage.getItem("fullName");

    if (storedFullName) {
      setFullName(storedFullName);
    }
  }, []);

  const [planStatus, setPlanStatus] = useState("checking");
  useEffect(() => {
    const checkStatus = async () => {
      const result = await checkPlanStatus();
      if (result === "active") {
        setPlanStatus("active");
        const hasChatbotAccess = true;
        console.log("✅ Welcome");
      } else if (result === "expired") {
        setPlanStatus("expired");
        navigate("/dashboard/payment_card");
      }
    };

    checkStatus();
  }, [navigate]);

  const handleLogout = async () => {
    const { secrettoken, ts } = await getSecureToken();

    try {
      const response = await axios.post(`${API_BASE_URL}logout.php`, {}, {
        headers: {
          'X-TOKEN': secrettoken,
          'X-TIMESTAMP': ts
        },
        withCredentials: true,
      });

      if (response.data.status === "success") {
        const theme = localStorage.getItem("theme");
        localStorage.clear();
        if (theme) {
          localStorage.setItem("theme", theme);
        }
        window.location.href = "/";
      }
    } catch (error) {
      console.log("Logout error:", error);
    }
  };

  return (
    <>
      <div className={`${style.da} container-fluid`}>
        <div className={`${style.dashboard} row`}>
          {!isMobileView && (
            <div className={`${style.leftpannel} col-2`}>
              <div className={style.header__logo}>
                <h1 className={style.header__title}>
                  <span className={style.header__light}>SWING</span>
                  <span className={style.header__light}></span>ALGO
                </h1>
              </div>

              {/* <div className={style.dashboardlink}>
                {menuItems.map((item) => (
                  <div key={item.path} className={`${style.dash} ${location.pathname === item.path ? style.active : ''}`} onClick={() => navigate(item.path)}>
                    <button className={style.dashlink}>
                      <i className={`${item.icon} ${style.dashicon}`}></i>
                      <span className={style.dashtxt}>{item.name}</span>
                    </button>
                  </div>
                ))}
              </div> */}

              <div className={style.dashboardlink}>
                {menuItems.map((item) => {
                  const isLocked =
                    (planStatus === "expired" &&
                      item.path !== "/dashboard/payment_card") ||
                    item.disabled;

                  return (
                    <div
                      key={item.path}
                      className={`${style.dash} ${location.pathname === item.path ? style.active : ""
                        }`}
                      onClick={() => {
                        if (!isLocked) navigate(item.path);
                      }}
                      style={{
                        opacity: isLocked ? 0.5 : 1,
                        cursor: isLocked ? "not-allowed" : "pointer",
                      }}
                    >
                      <button className={style.dashlink} disabled={isLocked}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {isLocked && (
                            <i
                              className="fa-solid fa-lock"
                              style={{
                                fontSize: "0.8rem",
                                marginBottom: "3px",
                                color: "red",
                              }}
                            ></i>
                          )}
                          <i className={`${item.icon} ${style.dashicon}`}></i>
                        </div>
                        <span className={style.dashtxt}>{item.name}</span>
                      </button>
                    </div>
                  );
                })}
              </div>
              {/* <div className={style.dashboardlink}>
                {menuItems.map((item) => (
                  <div
                    key={item.path}
                    className={`${style.dash} ${location.pathname === item.path ? style.active : ''}`}
                    onClick={() => {
                      if (!item.disabled) navigate(item.path);
                    }}
                    style={{ opacity: item.disabled ? 0.5 : 1, cursor: item.disabled ? 'not-allowed' : 'pointer' }}
                  >
                    <button className={style.dashlink} disabled={item.disabled}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {item.disabled && <i className="fa-solid fa-lock" style={{ fontSize: '0.8rem', marginBottom: '3px', color: 'red' }}></i>}
                        <i className={`${item.icon} ${style.dashicon}`}></i>
                      </div>
                      <span className={style.dashtxt}>{item.name}</span>
                    </button>
                  </div>
                ))}
              </div> */}

              <div className={style.logoutbtn}>
                <button className={style.logout} onClick={handleLogout}>
                  <i
                    className={`${style.logouticon} fa-solid fa-right-from-bracket`}
                  ></i>
                  <span className={style.logoutword}>Logout</span>
                </button>
              </div>
            </div>
          )}

          <div
            className={`${style.dashboardcenter} ${isMobileView ? "col" : "col"
              }`}
          >
            <div className={`${style.dashfluid} container-fluid`}>
              <div className={`${style.dashboardheader} row`}>
                <div className={`${style.dashboardwrite} col`}>
                  {isMobileView && (
                    <div
                      className={`col d-flex justify-content-between d-lg-none `}
                    >
                      <h1
                        className={style.header__title}
                        style={{ alignContent: "center" }}
                      >
                        <span className={style.header__light}>SWING</span>
                        <span className={style.header__light}></span>ALGO
                      </h1>

                      <ThemeToggle />
                    </div>
                  )}
                  {/* {menuItems
                    .find((item) => item.path === location.pathname)
                    ?.name.toUpperCase() || "DASHBOARD"} */}
                    {activeTitle}

                </div>
                <div className={`${style.dashright} col d-flex`}>
                  <div
                    className={`col text-end me-4 d-flex gap-5 justify-content-end`}
                  >
                    <ThemeToggle />
                    <button
                      className={style.notificationicon}
                      onClick={() =>
                        setNotificationBarOpen(!isNotificationBarOpen)
                      }
                    >
                      <i className={`fa-solid fa-bell`}></i>
                      {/* {notifications.length > 0 && <span className={style.notificationCount}>!</span>} */}
                    </button>
                  </div>
                  <div
                    className={`${style.profilename} col d-flex`}
                    onClick={() => setProfileModalOpen(true)}
                  >
                    <div className={style.name}>{userEmail}</div>
                    <div className="col align-content-center">
                      <i className={`${style.profileimg} fa-solid fa-user`} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Routes>
              <Route path="/" element={<DashboardLanding />} />
              <Route path="/workshop" element={<ViewWorkshops />} />
              <Route path="/scanners/*" element={<Scaner />} />
              <Route path="/study-material" element={<StudyMaterial_data />} />
              <Route path="/fundamental/*" element={<Fundamentaldash />} />
              {/* <Route path="/sector-rotation" element={<Sector_rotation />} /> */}
              <Route path="/sector-rotation" element={<Sector />} />
              <Route path="/community-group" element={<Community_data />} />
              <Route path="/news-events/*" element={<News />} />
              <Route path="/payment_card" element={<Premium />} />
              <Route path="/ai-chatbot/*" element={<AI_bot />} />
              {/* <Route path="/stock/:symbol" element={<StockAnalysis />} />
              <Route path="/stock/:symbol/chat" element={<StockChat />} /> */}
            </Routes>
            <SubscriptionPopup />
          </div>
        </div>
      </div>

      {/* Profile Edit Modal */}
      <ProfileEditModal
        isOpen={isProfileModalOpen}
        onClose={closeProfileModal}
      />

      {/* Notification Bar */}
      <div ref={notificationBarRef}>
        <NotificationBar
          isOpen={isNotificationBarOpen}
          onClose={toggleNotificationBar}
          notifications={notifications}
        />
      </div>

      {/* Bottom Navigation Bar for Mobile View */}

      {isMobileView && (
        <div
          className={`${style.mobileNav} fixed-bottom d-flex justify-content-around`}
        >
          <button
            onClick={() => handleSectionChange("/dashboard")}
            className={style.navButton}
          >
            <i className="fa-solid fa-house"></i>
            <span className={style.navText}>Dashboard</span>
          </button>

          <button
            onClick={() => handleSectionChange("/dashboard/scanners")}
            className={style.navButton}
          >
            <i className="fa-solid fa-magnifying-glass"></i>
            <span className={style.navText}>Scanners</span>
          </button>

          <button
            onClick={() => handleSectionChange("/dashboard/workshop")}
            className={style.navButton}
          >
            <i className="fa-solid fa-chalkboard"></i>
            <span className={style.navText}>Workshop</span>
          </button>

          <button
            onClick={() => handleSectionChange("/dashboard/fundamental")}
            className={style.navButton}
          >
            <i className="fa-solid fa-chart-line"></i>
            <span className={style.navText}>Fundamental</span>
          </button>
          <button
            onClick={() => handleSectionChange("/dashboard/sector-rotation")}
            className={style.navButton}
          >
            <i className="fa-solid fa-exchange-alt"></i>
            <span className={style.navText}>Sectors </span>
          </button>

          <button onClick={toggleNotificationBar} className={style.navButton}>
            <i className={`fa-solid fa-bell`}></i>
            {/* {notifications.length > 0 && (
              <span className={style.notificationCount2}>{notifications.length}</span>
            )} */}
          </button>

          <div className={` ${style.dropup} dropup-center dropup`}>
            <button
              className={` ${style.dropupbtn} btn btn-secondary dropdown-toggle1`}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa-solid fa-caret-up"></i>
            </button>

            <ul className={` ${style.dropupmenu} dropdown-menu `}>
              <li className="py-2">
                {" "}
                <button
                  onClick={handleProfileClick}
                  className={style.navButton}
                >
                  <i className={`fa-solid fa-user px-2`}></i>
                  <span className={style.dropText}>Profile</span>
                </button>
              </li>

              <li className="py-2">
                <button
                  onClick={() =>
                    handleSectionChange("/dashboard/community-group")
                  }
                  className={style.navButton}
                >
                  <i className={`fa-solid fa-users px-2`}></i>
                  <span className={style.dropText}>Community</span>
                </button>
              </li>

              <li className="py-2">
                <button
                  onClick={() =>
                    handleSectionChange("/dashboard/study-material")
                  }
                  className={style.navButton}
                >
                  <i className={`fa-solid fa-book px-2`}></i>
                  <span className={style.dropText}>Study Material</span>
                </button>
              </li>

              <li className="py-2">
                <button
                  onClick={() => handleSectionChange("/dashboard/news-events")}
                  className={style.navButton}
                >
                  <i className={`fa-solid fa-newspaper px-2`}></i>
                  <span className={style.dropText}>News & Events</span>
                </button>
              </li>

              <li className="py-2">
                <button
                  onClick={() => handleSectionChange("/dashboard/payment_card")}
                  className={style.navButton}
                >
                  <i className={`fa-solid fa-shield px-2`}></i>
                  <span className={style.dropText}>PREMIUM</span>
                </button>
              </li>
              <li className='py-2'>

                <button onClick={() => handleSectionChange('/dashboard/ai-chatbot')} className={style.navButton}>
                  <i className="fa-solid fa-robot px-2"></i>
                  <span className={style.dropText}>Chatbot</span>
                </button>
              </li>

              {/* <li className="py-2">
                <button
                  className={style.navButton}
                  onClick={(e) => e.preventDefault()}
                  disabled
                  style={{
                    opacity: 0.5,
                    cursor: "not-allowed",
                    position: "relative",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <i
                    className="fa-solid fa-lock"
                    style={{
                      fontSize: "1rem",
                      color: "red",
                      marginBottom: "3px",
                    }}
                  ></i>

                  <i className="fa-solid fa-robot"></i>
                  <span className={style.dropText}>Chatbot</span>
                </button>
              </li> */}

              <li className="py-2">
                <button className={style.logout} onClick={handleLogout}>
                  <i
                    className={`${style.logouticon} fa-solid fa-right-from-bracket`}
                  ></i>
                  <span className={style.logoutword}>Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
